import styled from 'styled-components';
import { DownloadSimple, Star, Globe } from '@phosphor-icons/react';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { STATS } from '@/utils/constants';
import { theme } from '@/styles/theme';

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.lg};
  }
`;

const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.md};
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.primary.extraLight};
  color: ${theme.colors.primary.main};
`;

const StatValue = styled.div`
  font-size: ${theme.fontSizes['3xl']};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.black};
`;

const StatLabel = styled.div`
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.text.gray};
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: ${theme.spacing.xxl};
  color: ${theme.colors.text.black};
`;

export const SocialProofSection = () => {
  return (
    <Section $padding="large" $background={theme.colors.white}>
      <Container>
        <Title>Trusted by language learners worldwide</Title>
        <StatsGrid>
          <StatCard>
            <IconWrapper>
              <DownloadSimple size={24} weight="duotone" />
            </IconWrapper>
            <StatValue>{STATS.downloads}</StatValue>
            <StatLabel>Downloads</StatLabel>
          </StatCard>
          <StatCard>
            <IconWrapper>
              <Star size={24} weight="duotone" />
            </IconWrapper>
            <StatValue>{STATS.rating}★</StatValue>
            <StatLabel>Average Rating</StatLabel>
          </StatCard>
          <StatCard>
            <IconWrapper>
              <Globe size={24} weight="duotone" />
            </IconWrapper>
            <StatValue>{STATS.languages}</StatValue>
            <StatLabel>Languages Planned</StatLabel>
          </StatCard>
        </StatsGrid>
      </Container>
    </Section>
  );
};
